import React from "react";
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Slide,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { PDFViewer } from "@react-pdf/renderer";
import InvoiceDocument from "../../InvoiceDocument";
// import InvoiceDocument from "../InvoiceDocument";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProformaPreviewModal = ({
  open,
  onClose,
  colors,
  invoiceData,
  lineItems,
  bookingDetails,
  hotelProfile,
  gstEnabled,
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative", backgroundColor: colors.primary[500] }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            Proforma Invoice Preview
          </Typography>
          <Button autoFocus color="inherit" onClick={onClose}>
            Close
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ p: 0, height: "100%", backgroundColor: "#525659" }}>
        <PDFViewer width="100%" height="100%" style={{ border: "none" }}>
          <InvoiceDocument
            invoiceData={invoiceData}
            items={lineItems}
            bookingDetails={bookingDetails}
            hotelProfile={hotelProfile}
            gstEnabled={gstEnabled}
          />
        </PDFViewer>
      </DialogContent>
    </Dialog>
  );
};

export default ProformaPreviewModal;